<div class="modal-header align-items-start">
  <div ngbAutofocus>
    <h5 class="modal-title fw-bold mb-0">
      {{ mode === 'edit' ? 'แก้ไขใบรับรอง' : mode === 'view' ? 'ดูใบรับรอง' : 'เพิ่มใบรับรอง' }}
    </h5>
  </div>
  <button type="button" class="btn-close" (click)="cancel()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold" for="certificateNo">เลขที่ใบรับรอง <span
          class="text-danger">*</span></label>
        <input id="certificateNo" type="text" class="form-control form-control-sm" formControlName="certificateNo"
               [class.is-invalid]="isInvalid('certificateNo')">
        @if (isPending('certificateNo')) {
          <div class="form-text">กำลังตรวจสอบเลขที่ใบรับรอง...</div>
        }
        @if (isInvalid('certificateNo')) {
          @if (hasError('certificateNo', 'certificateNoTaken')) {
            <div class="invalid-feedback d-block">เลขที่ใบรับรองนี้มีอยู่แล้วในระบบ</div>
          } @else {
            <div class="invalid-feedback d-block">กรุณากรอกเลขที่ใบรับรอง</div>
          }
        }
      </div>
      <div class="col-12">
        <label class="form-label fw-semibold" for="standardName">ชื่อมาตรฐาน <span class="text-danger">*</span></label>
        @if (manualLayout) {
          <input id="standardName" type="text" class="form-control form-control-sm" formControlName="standardName"
                 placeholder="เช่น GMP, HACCP" [class.is-invalid]="isInvalid('standardName')">
        } @else {
          <app-standard-code-autocomplete id="standardName"
                                          formControlName="standardName"
                                          bindValue="title"
                                          size="sm"
                                          [class.is-invalid]="isInvalid('standardName')"
                                          (standardSelected)="onStandardSelected($event)">
          </app-standard-code-autocomplete>
        }
        @if (isInvalid('standardName')) {
          <div class="invalid-feedback d-block">กรุณากรอกชื่อมาตรฐาน</div>
        }
      </div>

      @if (!manualLayout) {
        <div class="col-12">
          <label class="form-label fw-semibold" for="productName">ชื่อชนิดสินค้า</label>
          <input id="productName" type="text" class="form-control form-control-sm" formControlName="productName">
        </div>
      }

      <div class="col-12">
        <label class="form-label fw-semibold" for="issuingDepartment">หน่วยงานที่ออกใบรับรอง <span
          class="text-danger">*</span></label>
        @if (manualLayout) {
          <input id="issuingDepartment" type="text" class="form-control form-control-sm"
                 formControlName="issuingDepartmentName" [class.is-invalid]="isInvalid('issuingDepartmentName')">
          @if (isInvalid('issuingDepartmentName')) {
            <div class="invalid-feedback d-block">กรุณากรอกหน่วยงานที่ออกใบรับรอง</div>
          }
        } @else {
          <app-department-autocomplete id="issuingDepartment" formControlName="issuingDepartment"
                                       size="sm"
                                       [class.is-invalid]="isInvalid('issuingDepartment')"></app-department-autocomplete>
          @if (isInvalid('issuingDepartment')) {
            <div class="invalid-feedback d-block">กรุณากรอกหน่วยงานที่ออกใบรับรอง</div>
          }
        }
      </div>

      <div class="col-12">
        <label class="form-label fw-semibold" for="description">รายละเอียด</label>
        <textarea id="description" class="form-control form-control-sm" formControlName="description"
                  rows="3"></textarea>
      </div>
    </div>

    @if (!manualLayout) {
    <div class="row g-3 mb-4">
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold" for="sizeFarm">ขนาดฟาร์ม</label>
        <input id="sizeFarm" type="number" class="form-control form-control-sm" formControlName="sizeFarm"
               placeholder="เช่น 12.5"
               step="0.01" min="0">
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold" for="unitFarm">หน่วย</label>
        <input id="unitFarm" type="text" class="form-control form-control-sm" formControlName="unitFarm"
               placeholder="ไร่ / งาน / ตารางวา">
      </div>
    </div>
    }

    <div class="row g-3 mb-4">
      <div class="col-12">
        <label class="form-label fw-semibold" for="certificateAttachment">ไฟล์ใบรับรอง (PDF หรือรูป)</label>
        @if (existingAttachmentUrl; as url) {
          <div class="d-flex flex-wrap align-items-center gap-2 mb-2 certificate-attachment-current">
            <i class="bi bi-paperclip" aria-hidden="true"></i>
            <a [href]="url" target="_blank" rel="noopener">{{ initialValue?.attachmentName || 'ดูไฟล์แนบ' }}</a>
            @if (mode !== 'view') {
              <button type="button" class="btn btn-sm btn-link text-danger p-0" (click)="dropExistingAttachment()">ลบไฟล์แนบ</button>
            }
          </div>
        } @else if (mode === 'view') {
          <div class="text-secondary small">ไม่มีไฟล์แนบ</div>
        }
        @if (mode !== 'view') {
          <app-file-upload inputId="certificateAttachment"
                           accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
                           hint="ไฟล์ PDF, PNG, JPG ขนาดไม่เกิน 5 MB"
                           (fileSelected)="onAttachmentPicked($event)"></app-file-upload>
          @if (attachmentError(); as error) {
            <div class="invalid-feedback d-block">{{ error }}</div>
          }
        }
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">วันที่รับรองเริ่มต้น <span class="text-danger">*</span></label>
        <gt-ng-datepicker formControlName="startDate" [required]="true" inputSize="sm"></gt-ng-datepicker>
        @if (isInvalid('startDate')) {
          <div class="invalid-feedback d-block">กรุณาเลือกวันที่เริ่มต้น</div>
        }
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">วันที่รับรองสิ้นสุด <span class="text-danger">*</span></label>
        <gt-ng-datepicker formControlName="endDate" [required]="true" [minDateString]="today"
                          inputSize="sm"></gt-ng-datepicker>
        @if (isInvalid('endDate')) {
          @if (hasError('endDate', 'dateBeforeToday')) {
            <div class="invalid-feedback d-block">วันที่สิ้นสุดต้องไม่น้อยกว่าวันที่ปัจจุบัน</div>
          } @else {
            <div class="invalid-feedback d-block">กรุณาเลือกวันที่สิ้นสุด</div>
          }
        }
      </div>
    </div>

    @if (mode !== 'view') {
      <div class="mt-4 d-flex justify-content-center">
        <button type="button" class="btn btn-primary d-flex align-items-center justify-content-center gap-2 px-4"
                [disabled]="checking()" (click)="save()">
          @if (checking()) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            กำลังตรวจสอบเลขที่ใบรับรอง...
          } @else {
            {{ mode === 'edit' ? 'บันทึกการแก้ไข' : 'บันทึก' }}
          }
        </button>
      </div>
    }
  </form>
</div>
